import axios from "axios";

class UsersError extends Error {
    constructor(errorCode, message) {
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.errorCode = errorCode;
    }
}

const UsersService = {
    authenticate: async function (username, password) {
        const requestData = {
            method: "post",
            url: "/api/users/authenticate",
            data: {
                username: username,
                password: password
            }
        };
        try {
            const response = await axios(requestData);
            return response.data;
        } catch (error) {
            const message = error.response.data.message ? error.response.data.message : error.response.data.errors[0].message;
            throw new UsersError(error.response.status, message);
        }
    },
    setPassword: async function (email, password, resetpassword) {
        const requestData = {
            method: "post",
            url: "/api/user/setPassword",
            data: {
                email: email,
                password: password,
                resetpassword: resetpassword
            }
        };
        try {
            const response = await axios(requestData);
            return response.data;
        } catch (error) {
            const message = error.response.data.message ? error.response.data.message : error.response.data.errors[0].message;
            throw new UsersError(error.response.status, message);
        }
    },
    signOut: async function () {
        const requestData = {
            method: "post",
            url: "/api/users/signout",
        };
        try {
            const response = await axios(requestData);
            return response.data;
        } catch (error) {
            const message = error.response.data.message ? error.response.data.message : error.response.data.errors[0].message;
            throw new UsersError(error.response.status, message);
        }
    },
    me: async function (username, password) {
        const requestData = {
            method: "get",
            url: "/api/users/me",
        };
        try {
            const response = await axios(requestData);
            return response.data;
        } catch (error) {
            const message = error.response.data.message ? error.response.data.message : error.response.data.errors[0].message;
            throw new UsersError(error.response.status, message);
        }
    },
    //TODO: decide if we should keep the hardcoding or do request to server instead
    permissions: function () {
        return {
            //users/authenticate/permissionenum
            ViewData: 0,
            NetworkRead: 1,
            NetworkWrite: 2,
            EeaRead: 3,
            EeaWrite: 4,
            Processing: 5,
            QualityControl: 6,
            UserWrite: 7,
            AllStations: 9,
            Accreditation: 10,
            AdacsRead: 11,
            AdacsWrite: 12,
            Maintenance: 13
        }
    },
};

export default UsersService;

export { UsersService, UsersError };
